import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Home } from "lucide-react";

const LOGO_URL = "https://firebasestorage.googleapis.com/v0/b/surveyappreact.firebasestorage.app/o/default%2Flogo_pb.svg?alt=media&token=e0035fbc-fa3e-4b6c-8ae5-81eac333c8e4";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <nav className="flex items-center h-16 w-full border-b border-gray-200 px-3">
        <button
          onClick={() => navigate("/workspaces")}
          className="h-16 w-[60px] flex items-center justify-center"
        >
          <img
            src={LOGO_URL}
            alt="PollBolt Logo"
            className="h-8 w-auto"
          />
        </button>
      </nav>

      <div className="flex-1 flex items-center justify-center px-4 -mt-16">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="text-center max-w-sm"
        >
          <div className="mb-6 flex justify-center">
            <img
              src="/images/nodata.svg"
              alt="Page not found"
              className="w-[180px]"
            />
          </div>

          <div className="flex items-center justify-center gap-2 mb-3">
            <img
              src="/images/upgradebolt.svg"
              alt=""
              className="w-5 h-5"
            />
            <span className="text-sm font-semibold text-gray-900">
              Oops!
            </span>
          </div>

          <h1 className="text-2xl font-normal text-gray-900 mb-3">
            This page doesn't exist
          </h1>

          <p className="text-sm text-gray-600 leading-relaxed mb-8">
            The page you're looking for may have been moved or doesn't exist anymore. Let's get you back on track.
          </p>

          <div className="flex gap-3 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="h-10 px-6 inline-flex items-center gap-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all text-sm font-normal tracking-[0.1px]"
            >
              <ArrowLeft size={16} />
              Go Back
            </button>
            <button
              onClick={() => navigate("/workspaces")}
              className="h-10 px-6 inline-flex items-center gap-2 bg-black text-white rounded-lg hover:bg-gray-900 transition-all text-sm font-normal tracking-[0.1px]"
            >
              <Home size={16} />
              Home
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;
